"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_urls_1 = require("@tableau/shared-urls");
var React = require("react");
exports.SiteUrlsContext = React.createContext(new shared_urls_1.SiteUrls({ siteUrlName: '' }));
//# sourceMappingURL=SiteUrlsContext.js.map